export default "__VITE_ASSET__D5n6s6Iq__"